<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Mail Grupları</h4>
                  <p class="card-category">Mail adreslerini, bir gruba kaydedin. Mailleri grup grup gönderin.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Oluştur
                  </button>
                </div>
              </div>

            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column"
                      :class="{ 'd-flex justify-content-center': column === tableColumns[tableColumns.length - 1] }">{{
                        column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item) in tableData" :key="item._id">
                  <slot :row="item">
                    <td>{{ item.title }}</td>
                    <td>{{ item.countRecord }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.isActive ? 'Evet' : 'Hayır' }}</td>
                    <td>{{ item.isSpecialGroup ? 'Evet' : 'Hayır' }}</td>
                    <td @click="openDeleteModal(item)">
                      <button>
                        <i class="nc-icon nc-simple-remove"></i>
                      </button>
                    </td>
                    <td @click="editMailGroup(item._id)"><button><i class="nc-icon nc-settings-tool-66"></i></button>
                    </td>

                    <td class="d-flex justify-content-center">
                      <button @click="downloadReport(item._id); downloadStatus[item._id] = 'Rapor İndirildi'"
                        :class="['btn btn-sm', downloadStatus[item._id] ? 'btn-success' : 'btn-primary']">

                        <strong style="color: black;">
                          {{ downloadStatus[item._id] ? downloadStatus[item._id] : 'Rapor İndir' }}

                        </strong>
                      </button>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>

            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :key="i"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i +
                    1 }}</a></li>



              </ul>
            </nav>

          </card>

        </div>

        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.group">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Taslağı silmek istediğinize emin misiniz?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="deleteModal = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Grup Kodu:</strong> {{ deleteModal.group.title }}</label><br>
                <label><strong>Kayıtlı Mail Sayısı:</strong> {{ deleteModal.group.total }}</label><br>
                <label><strong>Aktif Mail Sayısı:</strong> {{ deleteModal.group.countRecord }}</label><br>

              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteMailGroup(deleteModal.group._id)"
                  class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

const tableColumns = ['Grup İsmi', 'Aktif Mail Sayısı', 'Kayıtlı Mail Sayısı', 'Aktif Mi?', 'Özel Grup Mu?', 'Sil', 'Düzenle', 'Rapor İndir']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      deleteModal: {
        isOpened: false,
        template: null,
        title: '',
        countRecord: 0,
        countActive: 0
      },
      downloadStatus: { "test": "test" },
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
    }
  },
  mounted() {
    this.getMailGroups();
  },
  methods: {
    getMailGroups() {
      let q = {};
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('mailgroup', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.mailGroups;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);

        } else {
          console.log('error');
        }
      })
    },
    deleteMailGroup(_id) {
      CollectionService.deleteItem('mailgroup', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', "Grup Silindi.")
        this.deleteModal.isOpened = false;
        this.deleteModal.group = null;
        this.getMailGroups();
      })
    },
    openDeleteModal(group) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.group = group;
    },
    createNew() {
      this.$router.push(`/admin/mailgroups/create`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    downloadReport(id) {
      CollectionService.getCollectionItemWithId('mailgroup/report', id).then((res) => {
        if (res.success == true) {
          const filePath = res.filePath;

          const link = document.createElement('a');
          link.href = filePath;
          link.setAttribute('download', filePath);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.log('error');
        }
      })
    },
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getMailGroups();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    editMailGroup(_id) {
      this.$router.push(`/admin/mailgroups/${_id}`);
    },
  }
}
</script>
<style></style>